import { render } from "./invoice_template.vue?vue&type=template&id=37053ee5&scoped=true"
import script from "./invoice_template.vue?vue&type=script&lang=js"
export * from "./invoice_template.vue?vue&type=script&lang=js"

import "./invoice_template.vue?vue&type=style&index=0&id=37053ee5&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37053ee5"]])

export default __exports__